export const frontlinki = {
  items: [
    {
      link: "/oferta/szukaj.xml?dojazd=samolot&pobyt=6,14&sort=3&order=ASC",
      linkb: "",
      nazwa: "top",
      pozycja: "1",
      tytul: "Polecane oferty"
    },
    {
      link: "/oferta/szukaj.xml?dojazd=samolot&pobyt=6,14&dni=21",
      linkb: "/last-minute/oferty.xml?dojazd=samolot&pobyt=6,14",
      nazwa: "lm",
      pozycja: "2",
      tytul: "Kanary Last Minute"
    },
    {
      link: "/oferta/szukaj.xml?dojazd=samolot&pobyt=6,14&allInclusive=1",
      linkb: "/rodzaj-oferty/all-inclusive-wyspykanaryjskie.xml",
      nazwa: "allInclusive",
      pozycja: "3",
      tytul: "Kanary All Inclusive"
    }
  ]
};
